export default {"src":"/_next/static/media/channel.ed9ab5f2.svg","height":160,"width":160};